import CookieSettings from './CookieSettings';

export const cookieSettings = {
  firstLevel: CookieSettings,
};